import useSelectedNodes, {
  SelectedNodes,
} from 'components/canvas/components/bulk-select-provider/components/selection-rectangle/hooks/use-selected-nodes';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import { AuthorizationActions } from 'routes/surface/hooks/use-authorization';

interface UseSelectedNodesWithPermissionToMakeAnAction {
  selectedNodesAllowedToDelete: SelectedNodes;
  selectedNodesAllowedToReposition: SelectedNodes;
  selectedNodesAllowedToCut: SelectedNodes;
  selectedNodesAllowedToCopy: SelectedNodes;
}

export default function useSelectedNodesWithPermissionToMakeAnAction(
  surface: string,
): UseSelectedNodesWithPermissionToMakeAnAction {
  const authorization = useCurrentSurfacePermissions();

  const selectedNodes = useSelectedNodes(surface);

  const selectedNodesAllowedToDelete = filterSelectedNodesAllowedToDelete(
    selectedNodes,
    authorization,
  );

  const selectedNodesAllowedToReposition = filterSelectedNodesAllowedToReposition(
    selectedNodes,
    authorization,
  );

  const selectedNodesAllowedToCut = filterSelectedNodesAllowedToDelete(
    selectedNodes,
    authorization,
  );

  const selectedNodesAllowedToCopy = authorization.canCopySurfaceNode()
    ? selectedNodes
    : [];

  return {
    selectedNodesAllowedToDelete,
    selectedNodesAllowedToReposition,
    selectedNodesAllowedToCut,
    selectedNodesAllowedToCopy,
  };
}

function filterSelectedNodesAllowedToDelete(
  selectedNodes: SelectedNodes,
  authorization: AuthorizationActions,
): SelectedNodes {
  if (authorization.canDeleteSurfaceNode()) {
    return selectedNodes;
  }

  return selectedNodes.filter((node) =>
    authorization.canDeleteOwnedSurfaceNode(node),
  );
}

function filterSelectedNodesAllowedToReposition(
  selectedNodes: SelectedNodes,
  authorization: AuthorizationActions,
): SelectedNodes {
  if (authorization.canRepositionSurfaceNode()) {
    return selectedNodes;
  }

  return selectedNodes.filter((node) =>
    authorization.canRepositionSurfaceNode(node),
  );
}
